import restaurantOrdersActions from '../actionTypes/restaurantOrdersActions';

const initialState = {
  isLoading: true,
  data: [],
  openPrintStickersModal: false
};

const RestaurantOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case restaurantOrdersActions.getRestaurantOrders:
      return { ...state, isLoading: true };
    case restaurantOrdersActions.getRestaurantOrdersSuccess:
      return {
        ...state,
        ...action.payload,
        isLoading: false
      };
    case restaurantOrdersActions.getRestaurantOrdersFailed:
      return {
        ...state,
        ...action.payload,
        data: [],
        isLoading: false
      };
    case restaurantOrdersActions.resetToInitialState:
      return initialState;
    case restaurantOrdersActions.updateCompanyOrderStatus:
      return { ...state, ...action.payload, updatingStatus: true };
    case restaurantOrdersActions.updateCompanyOrderStatusSuccess:
      // Update company order status amongst all the orders
      const data = state.data.map(order =>
        order.id === action.payload.data.id
          ? { ...order, ...action.payload.data }
          : order
      );

      return {
        ...state,
        data,
        updatingStatus: false,
        openPrintStickersModal:
          action.payload.data.permissible_events[0] === 'Delivered',
        openPrintStickersModalId:
          action.payload.data.permissible_events[0] === 'Delivered' &&
          action.payload.data.id,
        id: null
      };
    case restaurantOrdersActions.togglePrintStickersModal:
      return {
        ...state,
        openPrintStickersModal: !state.openPrintStickersModal,
        openPrintStickersModalId: null
      };
    case restaurantOrdersActions.updateCompanyOrderStatusFailed:
      return { ...state, updatingStatus: false, id: null };
    default:
      return state;
  }
};

export default RestaurantOrdersReducer;
